import { ISelectOption } from '~/shared/components/Form/Select/types';

import { OfferResponseDTO } from '../dtos/OfferResponseDTO';

export function formatOffersToOptions(
  offers: OfferResponseDTO[] = []
): ISelectOption[] {
  return offers.map((offer) => ({ value: offer._id, label: offer.name }));
}
